import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconPenLine: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.125 6.02661C18.1258 5.41328 17.8876 4.83662 17.4534 4.40328L15.5967 2.54669C15.1626 2.11336 14.5876 1.87417 13.9734 1.875C13.3601 1.87584 12.7842 2.11578 12.3525 2.54995L2.0575 12.8925C1.94 13.01 1.875 13.1683 1.875 13.3333V17.5C1.875 17.845 2.155 18.125 2.5 18.125H6.66667C6.83167 18.125 6.99088 18.0592 7.10754 17.9433L17.45 7.6475C17.885 7.21584 18.1242 6.63995 18.125 6.02661ZM6.40828 16.8758H3.125V13.5925L10.6191 6.06415L13.9376 9.38161L6.40828 16.8758ZM16.5684 6.76249L14.8234 8.49996L11.5009 5.17833L13.2383 3.43252C13.435 3.23502 13.6967 3.12665 13.9758 3.12582H13.9766C14.255 3.12582 14.5167 3.23412 14.7142 3.43079L16.5708 5.28748C16.7675 5.48498 16.8758 5.74663 16.8758 6.0258C16.875 6.30413 16.7659 6.56583 16.5684 6.76249ZM18.125 17.5008C18.125 17.8458 17.845 18.1258 17.5 18.1258H11.6667C11.3217 18.1258 11.0417 17.8458 11.0417 17.5008C11.0417 17.1558 11.3217 16.8758 11.6667 16.8758H17.5C17.845 16.8758 18.125 17.1558 18.125 17.5008Z"
      fill={color}
    />
  </svg>
);

export default IconPenLine;
